import type { IconSvgObject } from './types';

const DamIcon: IconSvgObject = [
  ["path", { d: "M2 20V4C2 3.44772 2.44772 3 3 3H5.11075C5.61784 3 6.04465 3.37955 6.1039 3.88316L8 20C8 20.5523 7.55228 21 7 21H3C2.44772 21 2 20.5523 2 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12C21.4 11.5 20.8 11 19.5 11C17 11 17 13 14.5 13C11.9 13 12.1 11 9.5 11C8.57595 11 7.99344 11.2732 7.5 11.6177", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 18C21.4 17.5 20.8 17 19.5 17C17 17 17 19 14.5 19C11.9 19 12.1 17 9.5 17C8.86664 17 8.39374 17.1284 8 17.3201", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DamIcon;
